<template>
  <div>
    <v-textarea
      outlined
      v-model="data.Records[0].value"
      :label="label"
      :rows="rows"
      :rules="rules"
      :disabled="disabled"
      background-color="white"
    ></v-textarea>
  </div>
</template>

<script>
export default {
  /*
   */
  props: {
    record: Object,
    label: String,
    init: String,
    rows: Number,
    rules: Array,
    disabled: Boolean,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [{ value: this.init, form_id: 0, form_type: 8 }],
      },
    };
  },
  async mounted() {
    this.data.Records[0].value = this.init;
  },
};
</script>

<style>
/*@import "../../../../../css/styles.css";*/
</style>
